import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * P9301 module permission hook
 * pgCode = "pw9301f1"
 */
export function useP9301Permissions() {
  return useModulePermission(Modules.P9301);
}
